import {
    OriginDeterminationState,
    OriginDetermination,
    OriginDeterminationItem
} from "./types";
import {MutationTree, GetterTree, Module} from "vuex";
import {RootState} from "@/store/types";

export const state: OriginDeterminationState = {
    selected_item: {
        id_item: 0,
        id_costumer: 0,
        item_type: "",
        item_code: "",
        item_name: ""
    },
    selected_origin_determination: {
        originating: false,
        start_application_date: '',
        id_agreement: '',
        product_specific_rule: '',
        main_product_specific_rule: '',
        rule_method_percentage: '',
        originating_de_minimis: false,
        originating_rvc: false
    }
}

const mutations: MutationTree<OriginDeterminationState> = {
    SET_SELECTED_ITEM(state, selectedItem: OriginDetermination) {
        state.selected_item = selectedItem;
    },
    SET_CURRENT_SELECTED_ORIGIN_DETERMINATION(state, selectedItem: OriginDeterminationItem) {
        state.selected_origin_determination = selectedItem;
    }
}

const getters: GetterTree<OriginDeterminationState, RootState> = {
    SELECTED_ITEM(state): OriginDetermination {
        const {selected_item} = state;
        return {...selected_item}
    },
    CURRENT_SELECTED_ORIGIN_DETERMINATION(state): OriginDeterminationItem {
        const {selected_origin_determination} = state;
        return {...selected_origin_determination}
    }
}

export const origin_determination: Module<OriginDeterminationState, RootState> = {
    mutations,
    getters,
    state
}
